module.exports = __webpack_public_path__ + "static/nambi-40d2977a0342dfbd45d901a76f87a16a.png";